import { Form, Select, Input, DatePicker } from 'antd';
import { FormInstance } from 'antd/es/form';
import FormSection from '../FormSection';
import Calendar from '../svg/Calendar';

import CurvDown from '../svg/CurvDown';

const { Option } = Select;
const { TextArea } = Input;

interface HandicapProps {
  form: FormInstance;
}

const Handicap: React.FC<HandicapProps> = ({ form }) => {
  const handicapTypeOptions = ['Mental', 'Physical'];
  const disabilityAffectsOptions = [
    'Learning', 'Walking', 'Seeing', 'Hearing',
    'Speaking', 'Breathing', 'Working', 'Other'
  ];
  const yesNoOptions = ['Yes', 'No'];
  const howLearnedOptions = [
    'You provided the information in writing',
    'You told the accused verbally',
    'Medical records were provided',
    'Other'
  ];

  const isAccusedHandicapped = Form.useWatch(['handicap_info', 'accused_handicapped'], form);
  const disableAccusedFields = isAccusedHandicapped !== 'Yes';

  return (
    <FormSection title="Handicap" columns={3} className="handicap-section">
      <style dangerouslySetInnerHTML={{
        __html: `
        .handicap-section .ant-form-item-label {
          min-height: 30px !important;
          display: flex !important;
          align-items: flex-end !important;
          line-height: 1.2 !important;
          padding-bottom: 0px !important;
        }
        @media (min-width: 768px) {
          .handicap-section .ant-form-item-label {
            min-height: 55px !important;
            align-items: flex-end !important;
          }
        }
        .handicap-section .ant-form-item-label > label {
          margin-bottom: 11px !important;
        }
        @media (min-width: 768px) {
          .handicap-section .ant-form-item-label > label {
            margin-bottom: 16px !important;
          }
        }
      `}} />
      <Form.Item
        label="What type of handicap do you have?"
        name={['handicap_info', 'handicap_type']}
      >
        <Select placeholder="Select handicap type" suffixIcon={<CurvDown className="pt-[10px] md:pt-[14px]" />}>
          {handicapTypeOptions.map(option => (
            <Option key={option} value={option}>{option}</Option>
          ))}
        </Select>
      </Form.Item>

      <Form.Item
        label="Your disability affects your:"
        name={['handicap_info', 'disability_affects']}
      >
        <Select placeholder="Select how it affects you" suffixIcon={<CurvDown className="pt-[10px] md:pt-[14px]" />}>
          {disabilityAffectsOptions.map(option => (
            <Option key={option} value={option}>{option}</Option>
          ))}
        </Select>
      </Form.Item>

      <Form.Item
        label="Are you generally considered handicapped by other employees?"
        name={['handicap_info', 'generally_considered_handicapped']}
      >
        <Select placeholder="Select" suffixIcon={<CurvDown className="pt-[10px] md:pt-[14px]" />}>
          {yesNoOptions.map(option => (
            <Option key={option} value={option}>{option}</Option>
          ))}
        </Select>
      </Form.Item>

      <Form.Item
        label="Was the accused aware of your handicap?"
        name={['handicap_info', 'accused_aware_of_handicap']}
      >
        <Select placeholder="Select" suffixIcon={<CurvDown className="pt-[10px] md:pt-[14px]" />}>
          {yesNoOptions.map(option => (
            <Option key={option} value={option}>{option}</Option>
          ))}
        </Select>
      </Form.Item>

      <Form.Item
        label="Date the accused learned of your handicap"
        name={['handicap_info', 'date_accused_learned']}
      >
        <DatePicker format="DD-MM-YYYY" placeholder="Select Date" suffixIcon={<Calendar />} inputReadOnly />
      </Form.Item>

      <Form.Item
        label="How did he learn of it?"
        name={['handicap_info', 'how_accused_learned']}
      >
        <Select placeholder="Select" suffixIcon={<CurvDown className="pt-[10px] md:pt-[14px]" />}>
          {howLearnedOptions.map(option => (
            <Option key={option} value={option}>{option}</Option>
          ))}
        </Select>
      </Form.Item>

      <Form.Item
        label="Is the accused handicapped?"
        name={['handicap_info', 'accused_handicapped']}
      >
        <Select placeholder="Select" suffixIcon={<CurvDown className="pt-[10px] md:pt-[14px]" />} onChange={(val) => {
          if (val === 'No') {
            form.setFieldValue(['handicap_info', 'accused_handicap_type'], undefined);
            form.setFieldValue(['handicap_info', 'accused_handicap_description'], undefined);
          }
        }}>
          {yesNoOptions.map(option => (
            <Option key={option} value={option}>{option}</Option>
          ))}
        </Select>
      </Form.Item>

      <Form.Item
        label="What type of handicap does the accused have?"
        name={['handicap_info', 'accused_handicap_type']}
      >
        <Select placeholder="Select handicap type" disabled={disableAccusedFields} suffixIcon={<CurvDown className="pt-[10px] md:pt-[14px]" />}>
          {handicapTypeOptions.map(option => (
            <Option key={option} value={option}>{option}</Option>
          ))}
        </Select>
      </Form.Item>

      <Form.Item
        label="What is the accused's handicap?"
        name={['handicap_info', 'accused_handicap_description']}
      >
        <Input placeholder="Describe accused's handicap" disabled={disableAccusedFields} />
      </Form.Item>

      {/* <Form.Item
        label="Were you qualified for the job?"
        name={['handicap_info', 'qualified_for_job']}
      >
        <Select placeholder="Select">
          {yesNoOptions.map(option => (
            <Option key={option} value={option}>{option}</Option>
          ))}
        </Select>
      </Form.Item> */}

      {/* <Form.Item
        label="Does your handicap prevent you from performing your job requirements?"
        name={['handicap_info', 'handicap_prevents_job_performance']}
      >
        <Select placeholder="Select">
          {yesNoOptions.map(option => (
            <Option key={option} value={option}>{option}</Option>
          ))}
        </Select>
      </Form.Item> */}
    </FormSection>
  );
};

export default Handicap;

